/**
 * PurchasesIcon — pictograma „Achiziții" (sidebar / nav).
 *
 * Sursă: `pictograme/New folder (3)/SVG/Asset 76.svg` — bar chart cu săgeată
 * down pe coloana cea mai joasă (mirror simetric cu SalesIcon, metaforă vizuală
 * pentru ieșire bani / consum din cont).
 *
 * Identic ca pattern cu SalesIcon — stroke=currentColor, stroke-width 10
 * pentru paritate cu Lucide icons.
 */

interface PurchasesIconProps {
  className?: string;
  size?: number;
  'aria-hidden'?: boolean;
}

export function PurchasesIcon({
  className = '',
  size = 20,
  'aria-hidden': ariaHidden,
}: PurchasesIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 159.17 159.17"
      width={size}
      height={size}
      className={className}
      role={ariaHidden ? undefined : 'img'}
      aria-label={ariaHidden ? undefined : 'Achiziții'}
      aria-hidden={ariaHidden}
    >
      {/* Stack bars stânga (3 trepte descendente) */}
      <polyline
        points="83.45 112.72 83.45 33.19 53.67 33.19 53.67 112.72 31.61 112.72 31.61 1.83 1.83 1.83 1.83 112.72"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
      {/* Săgeata down + bar de pornire dreapta */}
      <polyline
        points="83.45 112.72 120.4 157.35 157.35 112.72 135.28 112.72 135.28 64.56 105.51 64.56 105.51 112.72"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
    </svg>
  );
}
